import * as React from "react"
import { cn } from "@/lib/utils"

export interface PhoneIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size of the icon in pixels
   * @default 20
   */
  size?: number
}

/**
 * Phone icon as SVG
 *
 * This icon represents phone number in the ANYW3AR app.
 * Used for phone number social links in user profiles.
 *
 * @example
 * ```tsx
 * <PhoneIcon />
 * <PhoneIcon size={24} />
 * ```
 */
export const PhoneIcon = React.forwardRef<SVGSVGElement, PhoneIconProps>(
  ({ size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("inline-flex shrink-0", className)}
        aria-hidden="true"
        {...props}
      >
        <path
          d="M4.6,11.4c-.8-.8-1.5-1.6-2.1-2.5-.6-.9-1.1-1.7-1.5-2.6-.4-.9-.6-1.7-.6-2.5s0-1,.3-1.5c.2-.5.5-.9.9-1.3.5-.4,1-.7,1.6-.7s.5,0,.7.1c.2,0,.4.2.6.5l1.7,2.4c.1.2.2.4.3.5,0,.2.1.3.1.5s0,.4-.2.6c-.1.2-.2.3-.4.5l-.6.6c0,0-.1.2-.1.3s0,.1,0,.2c0,0,0,.1,0,.1.1.2.4.6.7,1s.7.8,1.1,1.2c.4.4.8.8,1.2,1.1.4.3.7.6,1,.7,0,0,0,0,.1,0,0,0,.1,0,.2,0,.1,0,.2,0,.3-.1l.6-.6c.2-.2.4-.3.5-.4.2-.1.4-.2.6-.2s.3,0,.5.1c.2,0,.3.2.5.3l2.4,1.7c.2.2.4.3.5.6,0,.2.1.4.1.7s0,.5-.2.8c-.1.3-.3.5-.5.8-.4.4-.8.7-1.2.9-.5.2-1,.3-1.5.3-.8,0-1.6-.2-2.5-.6-.9-.4-1.7-.9-2.6-1.5-.9-.6-1.7-1.4-2.5-2.1Z"
          fill="currentColor"
        />
      </svg>
    )
  }
)

PhoneIcon.displayName = "PhoneIcon"
